import { api } from "../../api/apiSlice";

// In-app feedback (handoff §14, testing-phase only) - deliberately minimal,
// a capture/triage inbox, not a ticketing system. Submitting needs no
// permission (any logged-in user); listing/resolving needs
// Admin.ManageFeedback. branchId/branchCode/userId are captured
// automatically server-side from the submitter's token, never sent by the
// client.
export const feedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation({
      query: (body) => ({ url: "/feedback", method: "POST", data: body }),
      invalidatesTags: [{ type: "Feedback", id: "LIST" }],
    }),
    getFeedback: builder.query({
      query: (params) => ({ url: "/feedback", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((f) => ({ type: "Feedback", id: f.feedbackId })),
              { type: "Feedback", id: "LIST" },
            ]
          : [{ type: "Feedback", id: "LIST" }],
    }),
    resolveFeedback: builder.mutation({
      query: ({ feedbackId, resolvedRemark }) => ({
        url: `/feedback/${feedbackId}/resolve`,
        method: "PUT",
        data: { resolvedRemark },
      }),
      invalidatesTags: (result, error, { feedbackId }) => [
        { type: "Feedback", id: feedbackId },
        { type: "Feedback", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSubmitFeedbackMutation,
  useGetFeedbackQuery,
  useResolveFeedbackMutation,
} = feedbackApi;
